/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionProgressionStatus } from './CompetitionProgressionStatus';
import {
    CompetitionProgressionStatusFromJSON,
    CompetitionProgressionStatusFromJSONTyped,
    CompetitionProgressionStatusToJSON,
    CompetitionProgressionStatusToJSONTyped,
} from './CompetitionProgressionStatus';

/**
 * 
 * @export
 * @interface MyOccurrenceEntry
 */
export interface MyOccurrenceEntry {
    /**
     * The occurrence this entry is for, 1-indexed.
     * @type {number}
     * @memberof MyOccurrenceEntry
     */
    periodNumber: number;
    /**
     * 
     * @type {CompetitionProgressionStatus}
     * @memberof MyOccurrenceEntry
     */
    status: CompetitionProgressionStatus;
}



/**
 * Check if a given object implements the MyOccurrenceEntry interface.
 */
export function instanceOfMyOccurrenceEntry(value: object): value is MyOccurrenceEntry {
    if (!('periodNumber' in value) || value['periodNumber'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function MyOccurrenceEntryFromJSON(json: any): MyOccurrenceEntry {
    return MyOccurrenceEntryFromJSONTyped(json, false);
}

export function MyOccurrenceEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyOccurrenceEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'periodNumber': json['periodNumber'],
        'status': CompetitionProgressionStatusFromJSON(json['status']),
    };
}

export function MyOccurrenceEntryToJSON(json: any): MyOccurrenceEntry {
    return MyOccurrenceEntryToJSONTyped(json, false);
}

export function MyOccurrenceEntryToJSONTyped(value?: MyOccurrenceEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'periodNumber': value['periodNumber'],
        'status': CompetitionProgressionStatusToJSON(value['status']),
    };
}

